import styled from 'styled-components';
import StarRating from 'components/ui/StarRating/StarRating';
import Button from 'components/ui/Button/Button';
import { getProfilePicFromUser } from 'utils/images';

const CaptainCard = ({ captain, setSelectedCaptain, selectedCaptain }) => {
  const { public_id, first_name, rating, review_count, city, state } = captain;

  const selectCaptain = async () => {
    setSelectedCaptain(public_id);
  };

  return (
    <div>
      <div>
        <a href={`/users/${public_id}`} target="_blank" rel="noreferrer">
          <PFP alt="Captain" src={getProfilePicFromUser(captain)} />
        </a>
        <Name>{first_name}</Name>
        <State>{`${city}, ${state}`}</State>
        <RatingWrapper>
          <StarRating
            rating={rating > 0 ? parseFloat(rating).toPrecision(2) : null}
            count={review_count > 0 ? review_count : null}
          />
        </RatingWrapper>
      </div>
      <ButtonWrapper>
        <Button
          fullWidth
          variant="renter"
          text={selectedCaptain === public_id ? 'Selected' : 'Select captain'}
          onClick={selectCaptain}
          outline={selectedCaptain === public_id}
          disabled={selectedCaptain === public_id}
        />
      </ButtonWrapper>
    </div>
  );
};

const ButtonWrapper = styled.div`
  min-width: 145px;

  button[class*='disabled'] span {
    color: #0751c2 !important;
  }
`;

const Name = styled.div`
  font-weight: 600;
  margin: 10px 0;
  font-size: 14px;
`;

const State = styled.div`
  font-size: 13px;
`;

const RatingWrapper = styled.div`
  padding: 5px 0 15px 0;
  display: flex;
  justify-content: center;
`;

const PFP = styled.img`
  width: 60px;
  height: 60px;
  border: 1px solid #fff;
  border-radius: 50%;
`;

export default CaptainCard;
